(function documentModuleDefinition() {
    'use strict';

    angular.module('Document', ['ngFileUpload', 'ui.router', 'Config', 'Entities', 'CustomControls', 'ui.select', 'ui.selectExtend', 'TranslatedPaginator'
        , 'ClickOnce', 'FileDownloader', 'DoublyLinkedList', 'DocumentViewer'
    ])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function documentConfig(config, $stateProvider, loginProvider) {

                $stateProvider.state('document-find', {
                    url: "/Document/Find",
                    templateUrl: config.resourceUrl('/views/document/document-find.html'),
                    controller: 'DocumentFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENTCUSTOMER READ')
                });

                $stateProvider.state('document-find-pending', {
                    url: "/Document/Find/SignPending",
                    templateUrl: config.resourceUrl('/views/document/document-find.html'),
                    controller: 'DocumentFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENTCUSTOMER READ'),
                    params: { isSignPending: true }
                });

                $stateProvider.state('document-detail', {
                    url: "/Document/Detail/{id}",
                    templateUrl: config.resourceUrl('/views/document/document-detail.html'),
                    controller: 'DocumentDetailController',
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENTCUSTOMER READ')
                });

                $stateProvider.state('document-edit', {
                    url: "/Document/Edit/{id}",
                    templateUrl: config.resourceUrl('/views/document/document-edit.html'),
                    controller: 'DocumentEditController',
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENTCUSTOMER READ').and('DOCUMENTCUSTOMER SIGN')
                });
            }
        ]);
})();
